module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="tips-box">\n	' +
((__t = ( content )) == null ? '' : __t) +
'\n</div>';

}
return __p
};